Retorna agentes de IA roteáveis disponíveis para a organização autenticada.

Use este endpoint antes de `POST /public/v1/calls/` para descobrir quais valores de `ai_agent_id` podem ser usados e quais variáveis dinâmicas cada agente exige.

<ApiCodeExamples exampleId="agentsList" />

<ApiResponseExamples exampleId="agentsList" />

## Escopo obrigatório

- `agents.read`

## Endpoints

- `GET /public/v1/agents/`: lista paginada.
- `GET /public/v1/agents/{id}/`: detalhe de um agente.

O detalhe usa o mesmo formato de campo do item da lista.

## Query parameters

- `page` (`integer`, opcional): número da página.
- `page_size` (`integer`, opcional): quantidade de itens por página. Default `25`, máximo `100`.
- `search` (`string`, opcional): busca pelo nome do agente.
- `ordering` (`string`, opcional): `name` ou `-name`.

## Campos de resposta

- `id` (`uuid`): id público do agente para enviar como `ai_agent_id`.
- `name` (`string`): nome do agente.
- `variables` (`array<string>`): chaves de variáveis dinâmicas exigidas pelo agente. Toda chave listada aqui deve ser enviada em `dynamic_variables` ao criar a chamada.
- `transfer_target_required` (`boolean`): indica se `POST /public/v1/calls/` precisa incluir `transfer_target`.
- `requires_pre_call_script` (`boolean`): indica se `POST /public/v1/calls/` precisa incluir um `pre_call_script_id` válido.

A lista mostra apenas agentes ativos, outbound e que passam pela mesma validação de roteamento usada por campanhas e launcher. Agentes inbound nunca são aceitos para criação de chamada pela API pública.

## Erros esperados

- `401 Unauthorized`: token inválido, expirado, revogado, ausente ou bloqueado por IP.
- `403 Forbidden`: a credencial não possui `agents.read`.
- `404 Not Found`: o id do detalhe não está disponível para a organização.
- `429 Too Many Requests`: rate limit da credencial excedido.
